import axios from 'axios';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Alert} from 'reactstrap';
import Breadcrumb from '../../Layout/Breadcrumb';
import {
    FaUserAlt, FaDollarSign, FaDonate, FaCreditCard, FaEdit, FaForward, FaCubes,
    FaTrashAlt, FaPowerOff, FaToggleOn, FaServer, FaDatabase, FaListAlt, FaChartLine
} from "react-icons/fa";
import {Spinner} from 'react-bootstrap';
import {Link} from "react-router-dom";
import ModalComponent from "../../ModalComponent";

class DetailUserComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            user: {},
            error: false,
            messageError: '',
            loadPage: true,
            isNotification: false,
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            userKey: 0,
            alert: {
                error: false,
                message: ''
            },
        }
    }

    confirmModal = () => {
        this.setState({
            btnConfirmDisabled: true,
            isSpinner: true,
            isBtnConfirm: false,
        })

        let form = {
            userId: this.state.user.id,
            action: this.state.action,
        };
        // console.log(form)
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.put(process.env.REACT_APP_API_URL + '/api/admin/user/action', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data);
                this.setState({
                    isSpinner: false,
                });
                if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                    this.props.logOut();
                } else {
                    let user = this.state.user;
                    if (this.state.action === 'active' || this.state.action === 'deactive') {
                        user.email_verified_at = ref.data.email_verified_at;
                    }
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(ref.data.error, ref.data.message),
                            title: this.state.contentModal.title
                        },
                        user: user
                    })
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    isSpinner: false,
                    contentModal: {
                        title: this.state.contentModal.title,
                        modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                    },
                })
            })
    }

    modalBodyConfirm = (error, message) => {
        if (error) {
            return (
                <div className="text-center text-danger">
                    {message}
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    {message}
                </div>
            )
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getUserDetail(this.props.userId);

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if (this.props.isNotification) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getUserDetail = (userId) => {
        this.setState({
            isLoading: true
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get(process.env.REACT_APP_API_URL + '/api/admin/user/detailUser/' + userId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        user: ref.data.content,
                        loadPage: false,
                        isLoading: false
                    })
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                    loadPage: false,
                    isLoading: false
                })
            })
    }

    checkNotification = () => {
        if (this.state.isNotification) {
            return (
                <Alert color="success">
                    {this.state.textNotification}
                </Alert>
            );
        }
    }

    showModal = (action) => {
        let titleModal;
        let modalBody;
        if (action === 'active') {
            titleModal = 'Kích hoạt';
            modalBody = this.modalBody(action);
        } else if (action === 'deactive') {
            titleModal = 'Tắt kích hoạt';
            modalBody = this.modalBody(action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
        })
    }

    hiddenModal = () => {
        this.setState({
            userId: 0,
            action: '',
            isModal: false,
        })
    }

    modalBody = (action) => {
        if (action === 'active') {
            return (
                <div className="text-center">
                    Bạn có muốn kích hoạt khách hàng <b className="text-danger">{this.state.user.name}</b> này
                    không? <br/>
                </div>
            )
        } else if (action === 'deactive') {
            return (
                <div className="text-center">
                    Bạn có muốn tắt kích hoạt khách hàng <b className="text-danger">{this.state.user.name}</b> này
                    không? <br/>
                </div>
            )
        }
    }

    loginAsUser = () => {
        this.setState({
            isLoading: true
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let form = {
            userId: this.state.user.id,
        };

        axios.put(process.env.REACT_APP_API_URL + '/api/admin/user/loginAsUser', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then(async (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    let itemUserAdmin = {
                        userId: ref.data.aminId,
                        isAdmin: true
                    }
                    await this.props.updateInfoAdmin(itemUserAdmin);

                    let itemLogin = {
                        token: ref.data.token,
                        is2Fa: true,
                    }
                    await this.props.login(itemLogin);

                    let itemUser = {
                        user: ref.data.user,
                        menu: 'user',
                        sessionRole: 'user',
                        credit: ref.data.credit,
                    }
                    await this.props.saveUser(itemUser);

                    await this.setState({
                        isLoading: false
                    });

                    await this.props.redirectUserHome();
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error)
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                    loadPage: false,
                    isLoading: false
                })
            })

    }

    render() {
        // console.log(this.state.user)
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Chi tiết khách hàng"} page={"Khách hàng"}
                                        icon={<FaUserAlt className="breadcrumb-icon"/>}/>
                            <div className="row ml-3" style={{marginTop: 20}}>
                                <div className="col-md-12">
                                    {
                                        this.state.error ? (
                                            <Alert color="danger">
                                                <div className='text-center'>
                                                    {this.state.messageError}
                                                </div>
                                            </Alert>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.checkNotification()
                                    }
                                </div>
                            </div>
                            <div className="row gutters-sm">
                                <div className="col-md-4 mb-3">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex flex-column align-items-center text-center">
                                                <img src={this.state.user.text_avatar}
                                                     alt="avatar" className="rounded-circle" width="150"/>
                                                <div className="mt-3">
                                                    <h4>{this.state.user.name} </h4>
                                                    <p className="text-muted mb-1">{this.state.user.email}</p>
                                                    <p className="text-muted font-size-sm">{this.state.user.user_detail.address}</p>
                                                    <button
                                                        className="btn btn-outline-danger mr-1 mt-1"
                                                        onClick={() => this.loginAsUser()}
                                                    >
                                                        Login as User
                                                    </button>
                                                    <Link
                                                        to={'/admin/khach-hang/chinh-sua-khach-hang/' + this.props.userId}
                                                        className="btn btn-primary mr-1 mt-1">Chỉnh sửa</Link>
                                                    <Link to={'/'} className="btn btn-outline-success mr-1 mt-1">Gửi mail</Link>
                                                    {
                                                        this.state.user.email_verified_at ? (
                                                            <button className="btn btn-outline-info mr-1 mt-1"
                                                                type="button"
                                                                onClick={() => this.showModal('deactive')}
                                                            >
                                                                Tắt kích hoạt
                                                            </button>
                                                        ) : (
                                                            <button className="btn btn-outline-warning mr-1 mt-1"
                                                                    type="button"
                                                                    onClick={() => this.showModal('active')}
                                                            >
                                                                Kích hoạt
                                                            </button>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card mt-3">
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                <h6 className="mb-0"><FaDollarSign/> Số dư tài khoản</h6>
                                                <span className="text-muted">{this.state.user.sdtk} VNĐ</span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                <h6 className="mb-0"><FaDonate/> Tổng tiền đã nạp</h6>
                                                <span className="text-muted">{this.state.user.total_credit} VNĐ</span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                <h6 className="mb-0"><FaDonate/> Tổng tiền đã dùng</h6>
                                                <span
                                                    className="text-muted">{this.state.user.total_total_expenses} VNĐ</span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                <h6 className="mb-0"><FaCreditCard/> Tạo nạp tiền vào tài khoản</h6>
                                                <span className="text-muted">
                                                    <Link
                                                        to={'/admin/khach-hang/' + this.props.userId + '/tao-nap-tien-tai-khoan.html'}
                                                        className="payment-credit-total text-muted"
                                                    >
                                                        <FaEdit/>
                                                    </Link>
                                                </span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                <h6 className="mb-0"><FaListAlt/> Lịch sử giao dịch</h6>
                                                <span>
                                                    <Link
                                                        to={'/admin/khach-hang/' + this.props.userId + '/lich-su-thanh-toan.html'}
                                                        className="payment-credit-total text-muted"
                                                    >
                                                        <FaForward/>
                                                    </Link>
                                                </span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                <h6 className="mb-0"><FaChartLine/> Lịch sử hoạt động</h6>
                                                <span className="text-muted">
                                                    <Link
                                                        to={'/admin/khach-hang/' + this.props.userId + '/lich-su-hoat-dong.html'}
                                                        className="payment-credit-total text-muted"
                                                    >
                                                        <FaForward/>
                                                    </Link>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="card mb-3">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <h6 className="mb-0">Họ và tên</h6>
                                                </div>
                                                <div className="col-sm-9 text-muted">
                                                    {this.state.user.name}
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <h6 className="mb-0">Giới tính</h6>
                                                </div>
                                                <div className="col-sm-9 text-muted">
                                                    {this.state.user.user_detail.gender}
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <h6 className="mb-0">Phone</h6>
                                                </div>
                                                <div className="col-sm-9 text-muted">
                                                    {this.state.user.user_detail.phone}
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <h6 className="mb-0">Address</h6>
                                                </div>
                                                <div className="col-sm-9 text-muted">
                                                    {this.state.user.user_detail.address}
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <h6 className="mb-0">Role</h6>
                                                </div>
                                                <div className="col-sm-9 text-muted">
                                                    {this.state.user.role}
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <h6 className="mb-0">Email</h6>
                                                </div>
                                                <div className="col-sm-9 text-muted">
                                                    {this.state.user.email}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gutters-sm">
                                        <div className="col-sm-6 mb-3">
                                            <div className="card h-100">
                                                <div className="card-body">
                                                    <ul className="list-group list-group-flush">
                                                        <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                            <h6 className="mb-0"><FaCubes/> Tổng số dịch vụ</h6>
                                                            <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsUsing + this.state.user.service.cloudServerUsing
                                                                    + this.state.user.service.hostingUsing + this.state.user.service.vpsExpire
                                                                    + this.state.user.service.cloudServerExpire + this.state.user.service.hostingExpire
                                                                    + this.state.user.service.proxyUsing + this.state.user.service.proxyExpire
                                                                    + this.state.user.service.vpsUsUsing + this.state.user.service.vpsUsExpire
                                                                }
                                                            </span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                            <h6 className="mb-0"><FaToggleOn/> Đang sữ dụng</h6>
                                                            <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsUsing + this.state.user.service.cloudServerUsing
                                                                    + this.state.user.service.hostingUsing
                                                                }
                                                            </span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                            <h6 className="mb-0"><FaPowerOff/> Hết hạn</h6>
                                                            <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsExpire
                                                                    + this.state.user.service.cloudServerExpire + this.state.user.service.hostingExpire
                                                                }
                                                            </span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                            <h6 className="mb-0"><FaTrashAlt/> Hủy</h6>
                                                            <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsCancel + this.state.user.service.cloudServerCancel
                                                                    + this.state.user.service.hostingCancel
                                                                }
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.props.vps ? (
                                                <div className="col-sm-6 mb-3">
                                                    <div className="card h-100">
                                                        <div className="card-body">
                                                            <ul className="list-group list-group-flush">
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0"><FaServer/> Dịch vụ VPS</h6>
                                                                    <span className="text-muted">
                                                                        <Link
                                                                            to={'/admin/khach-hang/' + this.props.userId + '/danh-sach-vps-cua-khach-hang.html'}>
                                                                            Chi tiết
                                                                        </Link>
                                                                    </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Tổng số dịch vụ</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsUsing + this.state.user.service.vpsExpire
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Đang sữ dụng</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsUsing
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Hết hạn</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsExpire
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Hủy</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsCancel
                                                                }
                                                            </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        {
                                            this.props.vps_us ? (
                                                <div className="col-sm-6 mb-3">
                                                    <div className="card h-100">
                                                        <div className="card-body">
                                                            <ul className="list-group list-group-flush">
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0"><FaServer/> Dịch vụ VPS NN</h6>
                                                                    <span className="text-muted">
                                                                        <Link
                                                                            to={'/admin/khach-hang/' + this.props.userId + '/danh-sach-vps-us-cua-khach-hang.html'}>
                                                                            Chi tiết
                                                                        </Link>
                                                                    </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Tổng số dịch vụ</h6>
                                                                    <span className="text-muted">
                                                                        {
                                                                            this.state.user.service.vpsUsUsing + this.state.user.service.vpsUsExpire
                                                                        }
                                                                    </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Đang sữ dụng</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsUsUsing
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Hết hạn</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsUsExpire
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Hủy</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.vpsUsCancel
                                                                }
                                                            </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        {
                                            this.props.cloudServer ? (
                                                <div className="col-sm-6 mb-3">
                                                    <div className="card h-100">
                                                        <div className="card-body">
                                                            <ul className="list-group list-group-flush">
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0"><FaServer/> Dịch vụ Cloud
                                                                        Server</h6>
                                                                    <span className="text-muted">
                                                                <Link to={"/"}>Chi tiết</Link>
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Tổng số dịch vụ</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.cloudServerUsing + this.state.user.service.cloudServerExpire
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Đang sữ dụng</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.cloudServerUsing
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Hết hạn</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.cloudServerExpire
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Hủy</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.cloudServerCancel
                                                                }
                                                            </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        {
                                            this.props.hosting ? (
                                                <div className="col-sm-6 mb-3">
                                                    <div className="card h-100">
                                                        <div className="card-body">
                                                            <ul className="list-group list-group-flush">
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0"><FaDatabase/> Dịch vụ Hosting
                                                                    </h6>
                                                                    <span className="text-muted">
                                                                <Link
                                                                    to={'/admin/khach-hang/' + this.props.userId + '/danh-sach-hosting-cua-khach-hang.html'}>
                                                                    Chi tiết
                                                                </Link>
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Tổng số dịch vụ</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.hostingUsing + this.state.user.service.hostingExpire
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Đang sữ dụng</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.hostingUsing
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Hết hạn</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.hostingExpire
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Hủy</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.hostingCancel
                                                                }
                                                            </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        {
                                            this.props.proxy ? (
                                                <div className="col-sm-6 mb-3">
                                                    <div className="card h-100">
                                                        <div className="card-body">
                                                            <ul className="list-group list-group-flush">
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0"><FaDatabase/> Dịch vụ Proxy
                                                                    </h6>
                                                                    <span className="text-muted">
                                                                        <Link
                                                                            to={'/admin/khach-hang/' + this.props.userId + '/danh-sach-proxy-cua-khach-hang.html'}>
                                                                            Chi tiết
                                                                        </Link>
                                                                    </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Tổng số dịch vụ</h6>
                                                                    <span className="text-muted">
                                                                {
                                                                    this.state.user.service.proxyUsing + this.state.user.service.proxyExpire
                                                                }
                                                            </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Đang sữ dụng</h6>
                                                                    <span className="text-muted">
                                                                        {
                                                                            this.state.user.service.proxyUsing
                                                                        }
                                                                    </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Hết hạn</h6>
                                                                    <span className="text-muted">
                                                                        {
                                                                            this.state.user.service.proxyExpire
                                                                        }
                                                                    </span>
                                                                </li>
                                                                <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                                                    <h6 className="mb-0">Hủy</h6>
                                                                    <span className="text-muted">
                                                                        {
                                                                            this.state.user.service.proxyCancel
                                                                        }
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }
                                    </div>
                                </div>
                                <ModalComponent
                                    isModal={this.state.isModal}
                                    content={this.state.contentModal}
                                    isBtnConfirm={this.state.isBtnConfirm}
                                    isSpinner={this.state.isSpinner}
                                    btnConfirmDisabled={this.state.btnConfirmDisabled}
                                    hiddenModal={() => this.hiddenModal()}
                                    confirmModal={() => this.confirmModal()}
                                    alert={this.state.alert}
                                />
                            </div>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        vps: state.system.vps,
        proxy: state.system.proxy,
        vps_us: state.system.vps_us,
        cloudServer: state.system.cloudServer,
        hosting: state.system.hosting,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({type: 'logOut'}))
        },
        notification: (item) => {
            dispatch(({type: 'notification', item}))
        },
        login: (item) => {
            dispatch(({type: 'login', item}))
        },
        saveUser: (item) => {
            dispatch(({type: 'saveUser', item}))
        },
        updateCredit: (item) => {
            dispatch(({type: 'updateCredit', item}))
        },
        updateInfoAdmin: (item) => {
            dispatch(({type: 'updateInfoAdmin', item}))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DetailUserComponent);